import React from "react";

const schemaData = {
  "fagu-valley-a-hidden-gem-near-kufri-shimla": [
    {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id":
          "https://www.hoteltwintowers.com/blogs/fagu-valley-a-hidden-gem-near-kufri-shimla",
      },
      headline: "Fagu Valley: A Hidden Gem Near Kufri, Shimla",
      description:
        "Discover Fagu Valley, a hidden gem near Kufri, Shimla, known for apple orchards, misty forests, scenic views and peaceful Himalayan landscapes.",
      image:
        "https://www.hoteltwintowers.com/images/blogsimages/fagu-valley/fagu-valley-in-shimla-banner.png",
      author: {
        "@type": "Person",
        name: "The Twin Towers Hotel Kufri",
        url: "https://www.hoteltwintowers.com",
      },
      publisher: {
        "@type": "Organization",
        name: "The Twin Towers Hotel Kufri",
        logo: {
          "@type": "ImageObject",
          url: "https://www.hoteltwintowers.com/icons/logo.svg",
        },
      },
      datePublished: "2026-08-31",
      dateModified: "2026-08-31",
    },

    {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "The Twin Towers Hotel Kufri",
          item: "https://www.hoteltwintowers.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blogs",
          item: "https://www.hoteltwintowers.com/blogs",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Fagu Valley: A Hidden Gem Near Kufri, Shimla",
          item: "https://www.hoteltwintowers.com/blogs/fagu-valley-a-hidden-gem-near-kufri-shimla",
        },
      ],
    },
  ],
  "3-day-travel-itinerary-for-Kufri-fagu-chail": [
    {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home Page",
          item: "https://www.hoteltwintowers.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blogs",
          item: "https://www.hoteltwintowers.com/blogs/",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "3-Day Travel Itinerary for Kufri, Fagu & Chail",
          item: "https://www.hoteltwintowers.com/blogs/3-day-travel-itinerary-for-Kufri-fagu-chail",
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id":
          "https://www.hoteltwintowers.com/blogs/3-day-travel-itinerary-for-Kufri-fagu-chail",
      },
      headline: "3-Day Travel Itinerary for Kufri, Fagu & Chail",
      description:
        "Plan your perfect 3-day travel itinerary for Kufri, Fagu & Chail. Explore adventure activities, scenic viewpoints, heritage attractions, and the best places to visit in Chail.",
      image:
        "https://www.hoteltwintowers.com/images/blogsimages/travel-itinerary/banner.png",
      author: { "@type": "Person", name: "Twin Tower Hotel" },
      publisher: {
        "@type": "Organization",
        name: "Twin Tower Hotel",
        logo: {
          "@type": "ImageObject",
          url: "https://www.hoteltwintowers.com/icons/logo.svg",
        },
      },
      datePublished: "2026-06-22",
    },
  ],

  "himalayan-nature-park-a-complete-guide-to-kufris-wildlife-escape": [
    {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.hoteltwintowers.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blogs",
          item: "https://www.hoteltwintowers.com/blogs",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Himalayan Nature Park: A Complete Guide to Kufri’s Wildlife Escape",
          item: "https://www.hoteltwintowers.com/blogs/himalayan-nature-park-a-complete-guide-to-kufris-wildlife-escape",
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id":
          "https://www.hoteltwintowers.com/blogs/himalayan-nature-park-a-complete-guide-to-kufris-wildlife-escape",
      },
      headline:
        "Himalayan Nature Park: A Complete Guide to Kufri’s Wildlife Escape",
      description:
        "Explore Himalayan Nature Park in Kufri, a peaceful wildlife escape with rare Himalayan animals, scenic forest trails, and nearby tourist attractions in Kufri.",
      image:
        "https://www.hoteltwintowers.com/images/blogsimages/himalayan-nature-park/animals.png",
      author: { "@type": "Person", name: "The Twin Towers Hotel" },
      publisher: {
        "@type": "Organization",
        name: "Twin Tower Hotel",
        logo: {
          "@type": "ImageObject",
          url: "https://www.hoteltwintowers.com/icons/logo.svg",
        },
      },
      datePublished: "2026-05-29",
    },
  ],

  // 3. Underrated Tourist Places Blog
  "underrate-tourist-places-in-shimla-you-must-visit-in-2026": [
    {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.hoteltwintowers.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blogs",
          item: "https://www.hoteltwintowers.com/blogs",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Underrated Tourist Places in Shimla You Must Visit in 2026",
          item: "https://www.hoteltwintowers.com/blogs/underrate-tourist-places-in-shimla-you-must-visit-in-2026",
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id":
          "https://www.hoteltwintowers.com/blogs/underrate-tourist-places-in-shimla-you-must-visit-in-2026",
      },
      headline: "Underrated Tourist Places in Shimla You Must Visit in 2026",
      description:
        "Explore the best tourist places in Shimla for 2026. Discover hidden villages, scenic viewpoints, waterfalls, and peaceful destinations beyond the usual attractions.",
      image: [
        "https://www.hoteltwintowers.com/images/blogsimages/shimla-view.png",
        "https://www.hoteltwintowers.com/images/blogsimages/naldehra-golf.png",
      ],
      author: { "@type": "Organization", name: "Twin Tower Kufri" },
      publisher: {
        "@type": "Organization",
        name: "Twin Tower Hotel",
        logo: {
          "@type": "ImageObject",
          url: "https://www.hoteltwintowers.com/icons/logo.svg",
        },
      },
      datePublished: "2026-04-15",
    },
  ],
  "exploring-theog-from-kufri-a-perfect-day-trip-experience": [
    {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home Page",
          item: "https://www.hoteltwintowers.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blogs",
          item: "https://www.hoteltwintowers.com/blogs/",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Exploring Theog From Kufri: A Perfect Day Trip Experience",
          item: "https://www.hoteltwintowers.com/blogs/exploring-theog-from-kufri-a-perfect-day-trip-experience",
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id":
          "https://www.hoteltwintowers.com/blogs/exploring-theog-from-kufri-a-perfect-day-trip-experience",
      },
      headline: "Exploring Theog From Kufri: A Perfect Day Trip Experience",
      description:
        "Explore Theog from Kufri with this perfect day trip guide. Discover top attractions, travel tips, best time to visit, and things to do near Kufri.",
      image: [
        "https://www.hoteltwintowers.com/images/blogsimages/exploring-feature-img.png",
      ],
      author: {
        "@type": "Person",
        name: "The Twin Tower Hotel",
        url: "https://www.hoteltwintowers.com/",
      },
      publisher: {
        "@type": "Organization",
        name: "The Twin Tower Hotel",
        logo: {
          "@type": "ImageObject",
          url: "https://www.hoteltwintowers.com/icons/logo.svg",
        },
      },
      datePublished: "2026-07-20",
      dateModified: "2026-07-20",
    },
  ],
};

const BlogsSchema = ({ slug }) => {
  const currentSchema = schemaData[slug];

  // Protects the page from crashing if a blog slug doesn't have an exact schema match
  if (!currentSchema) return null;

  return (
    <React.Fragment>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(currentSchema),
        }}
      />
    </React.Fragment>
  );
};

export default BlogsSchema;
